import {useRef} from 'react';
import LinesSection from 'views/chat/components/sections/LinesSection.component';
import ConversationsSection from 'views/chat/components/sections/ConversationsSection.component';
import ChatSection from 'views/chat/components/sections/ChatSection.component';
import useAuthentication from 'hooks/useAuthentication.hook';
import NeoDialogo from 'design/design_components/neo/overlay/NeoDialog.base';
import NeoButtonMain from 'design/design_components/neo/button/NeoButtonMain.base';
import useChat from 'hooks/chat/useChat.hook';
import NeoButtonSecondary from 'design/design_components/neo/button/NeoButtonOutlined.base';
import { useChatAgentConversations } from 'hooks/chat/useChatAgentConversations.hook';

export default function ChatView() {
  const domChat = useRef();
  const authentication = useAuthentication();
  const chat = useChat();

  const { data: conversations, loading } = useChatAgentConversations({lineId: chat.selected.line?.id});

  const render = {
    ConversationsSection: {
      ContactConversationsList: {
        Footer: {
          isRender: true
        }
      }
    },
    ChatSection: {
      conversationContactInfo: {
        open: {
          isRender: false
        }
      }
    }
  }

  return (
    <div className='Chat AgentChat' ref={domChat}>
      {(domChat.current) &&
        <NeoDialogo
          custom="employee-status"
          visible={authentication.user.status === 'AWAY'}
          appendTo={domChat.current}
          closable={false}
          header="Tu disponibilidad es ausente"
          footer={<>
            <NeoButtonSecondary
              label="Cambiar a por terminar"
              onClick={() => authentication.update.status('TO_GET_OUT')}
              loading={authentication.isUpdatingStatus}
            />
            <NeoButtonMain
              label="Cambiar a disponible"
              onClick={() => authentication.update.status('ONLINE')}
              loading={authentication.isUpdatingStatus}
            />
          </>}
        >
          <p>Cambia tu estatus de disponibilidad para poder contestar conversaciones con tus clientes</p>
        </NeoDialogo>
      }

      <LinesSection />

      {
        (chat.selected.line) &&
        <ConversationsSection
          render={render.ConversationsSection}
          conversations={conversations}
          loading={loading}
        />
      }

      {
        (chat.selected.conversation) && 
        <ChatSection 
          render={render.ChatSection}
        />
      }
    </div>
  );
}